import { TARRIF_TAB } from 'context/reducers/tabs.type';
import { useAppContext } from 'hooks/useAppContext';
import React, { FC, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { isEmpty } from 'utils/isEmpty';

export const OutletWrapper: FC = () => {
  const {
    dispatch,
    state: {
      truckers: { activeDriver, meta },
      searchTruckers: { dataSearch },
      tabs: { activeTab },
    },
  } = useAppContext();

  const getSearchedBy = () => {
    if (!dataSearch?.wasSearchedByCpf) return null;
    return dataSearch?.wasSearchedByCpf ? 'cpf' : 'telefone';
  };

  const hasTabTarrif = useMemo(() => activeTab === TARRIF_TAB, [activeTab]);

  return (
    <Outlet
      context={{
        freight: meta?.freight,
        truckerId: activeDriver?.id,
        showDepositInfo: hasTabTarrif,
        dispatchToCaller: dispatch,
        truckerSearchedBy: getSearchedBy(),
        initialTruckerData: !isEmpty(dataSearch) ? dataSearch : undefined,
      }}
    />
  );
};
